// import React from "react";
import plutoImg_1 from "../images/plutoImage/plutoImg(1).jpg";
import plutoImg_2 from "../images/plutoImage/plutoImg(2).jpg";
import plutoImg_3 from "../images/plutoImage/plutoImg(3).jpg";
import plutoImg_4 from "../images/plutoImage/plutoImg(4).jpg";
const sliderItem = [
  {
    id: 1,
    itemName: "Dessert",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, molestias eum quae nulla adipisci quidem?",
    imageSrc: plutoImg_1,
    offer: " Lorem ipsum dolor sit amet consectetur adipisicing elit.",
  },
  {
    id: 2,
    itemName: "Noodles",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, molestias eum quae nulla adipisci quidem?",
    imageSrc: plutoImg_2,
    offer: " Lorem ipsum dolor sit amet consectetur adipisicing elit.",
  },
  {
    id: 3,
    itemName: "Pasta",
    desc: "Lorem ipsum dodrsdhdtfjtlor sit amet consectetur adipisicing elit. Dolorem, molestias eum quae nulla adipisci quidem?",
    imageSrc: plutoImg_3,
    offer: " Lorem ipsum dolor sit amet consefd adipisicing elit.",
  },
  {
    id: 4,
    itemName: " Cake",
    desc: "Lorem ipsum dolor sit adfbdshfhrmet consectetur adipisicing elit. Dolorem, molestias eum quae nulla adipisci quidem?",
    imageSrc: plutoImg_4,
    offer: " Lorem ipsum dolor sit dfgfjd consectetur adipisicing elit.",
  },
];

export default sliderItem;
